import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  linkedSignal,
  output,
} from '@angular/core'
import { HubtypeCaseSort } from 'models/hubtype-case-sort'
import { SortDirection } from 'models/sort-direction'

export interface SortMenuOption {
  key: HubtypeCaseSort
  label: string
  selected?: boolean
}

@Component({
  selector: 'app-sort-menu',
  templateUrl: './sort-menu.component.html',
  styleUrls: ['./sort-menu.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:click)': 'hideDropdown($event)',
  },
})
export class SortMenuComponent {
  readonly label = input('Sort')
  readonly options = input<SortMenuOption[]>([])
  readonly sortChange = output<SortMenuOption>()

  isDropdownOpen = false

  /** Linked to options(); updates when options change. Set explicitly when user selects an option (in-place mutation doesn't change options() reference). */
  sortDirection = linkedSignal<SortDirection | undefined>(
    () => this.options()?.find(o => o.selected)?.key.sortDirection
  )

  private readonly _eref = inject(ElementRef)

  /** On click outside of component, close the dropdown. */
  hideDropdown(event: MouseEvent) {
    if (
      this.isDropdownOpen &&
      !this._eref.nativeElement.contains(event.target)
    ) {
      this.isDropdownOpen = false
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen
  }

  onClickSortOption(option: SortMenuOption) {
    this.selectOption(option)

    this.isDropdownOpen = false
    this.sortChange.emit(option)
  }

  private selectOption(option: SortMenuOption) {
    this.options().forEach(o => (o.selected = false))
    option.selected = true
    this.sortDirection.set(option.key.sortDirection)
  }
}
